import { Injectable } from '@angular/core';
// import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { compare } from 'compare-versions';
import { BehaviorSubject, Subject } from 'rxjs';

import { DeviceControllerService, SiteDeviceControllerService } from '../../../shared/typescript-angular-client';
import { UserService } from '../../user.service';
import { DeviceService } from '../device.service';

import { BatteryService } from './cmd/battery.service';
import { EventService } from './cmd/event.service';
import { HourService } from './cmd/hour.service';
import { JoinloraService } from './cmd/joinlora.service';
import { OpenService } from './cmd/open.service';
import { ParamsService } from './cmd/params.service';
import { StockService } from './cmd/stock.service';
import { UniqueService } from './cmd/unique.service';
import { UpdateService } from './cmd/update.service';
import { ConnexionService } from './connexion.service';

@Injectable({
  providedIn: 'root',
})
export class UlinkBleService extends DeviceService {
  // public deconnexion_subject: Subject<any>;

  public device: any;
  public isConnected: boolean = false;
  public loader: any;
  mainVersion: string;
  rfidVersion: string;
  // ble: any;
  connectToOpenDoor: any;
  batteryValue: any;
  eventResponse: string;
  isEventsListVisible: any;
  eventSend: boolean;
  isTechInfoVisible: boolean;

  public updateProgress = new BehaviorSubject(0);

  constructor(
    // public ble: BLE,
    // public loadCtrl: LoadingController,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public batteryService: BatteryService,
    public eventService: EventService,
    public hourService: HourService,
    public joinLoraService: JoinloraService,
    public openService: OpenService,
    public paramsService: ParamsService,
    public stockService: StockService,
    public uniqueService: UniqueService,
    public updateService: UpdateService,
    public connexionService: ConnexionService,
    protected storage: Storage,
    protected deviceApi: DeviceControllerService,
    protected siteDeviceApi: SiteDeviceControllerService,
    protected userService: UserService,
    protected HTTP: HTTP
  ) {
    // this.deconnexion_subject = new Subject<any>();
    super(storage, deviceApi, siteDeviceApi, userService, HTTP);
    console.log('BleService constructor init');
  }

  public connect() {
    this.connexionService.deconnexion_subject.subscribe((res) => {
      console.log('BleService - deconnexion_subject update', res);
      this.connectSubject.next(res);
    });
    return this.connexionService.bleConnexion(this.device);
  }

  public initDevice(device, ble) {
    this.device = device;
    console.log('bleService - initDevice - device:', JSON.stringify(this.device));
    this.ble = ble;
    this.resetVariables();
    this.initCmd(ble);
    this.getVersion();
    this.initUser();
  }

  public resetVariables() {
    // Connexion
    this.isConnected = false;
    this.isConnecting = false;
    this.auto_connect = false;
    this.connectError = false;
    this.connexionLoader = null;
    this.mustActivate = false;

    // Action Update
    this.hasUpdate = false;
    this.updateInfos = null;
    this.isUpdating = false;
    this.percent = null;
    this.hasToUpdate = false;
    this.currentUpdate = null;
    this.checkUpdate = false;
    this.updateDispo = null;

    // Task
    this.tasksToSend = [];
    this.tasks = [];
    this.cmdFromTask = false;
    this.taskAction = null;
    this.paramIndex = null;
    this.paramsIsOk = false;
    this.taskResponse = null;
    this.currentCmdId = 0;
    this.currentTaskId = 0;
    this.mustSync = false;

    // Command
    this.sendingCmd = false;
    this.uniqueResponse = null;
    this.uniqueInput = null;
    this.cmd = null;
    this.getTask = null;

    this.bleService = null;
    this.currentAction = [];
    this.updateEnd = null;
    this.checkEventt = null;

    this.syncSubject = new Subject();
    this.connectSubject = new Subject();

    this.loader = null;
    this.mainVersion = null;
    this.rfidVersion = null;
    // ble: any;
    this.connectToOpenDoor = null;
    this.batteryValue = null;
    this.eventResponse = null;
    this.isEventsListVisible = null;
    this.eventSend = null;
    this.isTechInfoVisible = null;
  }

  public initCmd(ble) {
    this.openService.setDevice(this.device, ble);
    this.stockService.setDevice(this.device, ble);
    this.hourService.setDevice(this.device, ble);
    this.joinLoraService.setDevice(this.device, ble);
    this.eventService.setDevice(this.device, ble);
    this.paramsService.setDevice(this.device, ble);
    this.batteryService.setDevice(this.device, ble);
    this.updateService.setDevice(this.device, ble);
    this.uniqueService.setDevice(this.device, ble);
  }

  getVersion() {
    var main = this.device.properties.config.mainFwVersion;
    main = main.split('_');
    main = main[1].split('.');

    this.mainVersion = main[0] + '.' + main[1] + '.' + main[2];

    var rfid = this.device.properties.config.rfidFwVersion;
    rfid = rfid.split('_');
    rfid = rfid[2].split('.');

    this.rfidVersion = rfid[0] + '.' + rfid[1] + '.' + rfid[2];
  }

  bleNotifications() {
    console.log('Device AFTER start notifications', this.device);
    console.log('Notification : ', this.device.bleId, this.device.serviceUUID, this.device.txUUID);

    let test = this.device.serviceUbleIdUID;
    console.log(test);
    test = this.device.serviceUUID;
    console.log(test);
    test = this.device.txUUID;
    console.log(test);

    this.ble
      .startNotification(
        this.device.bleId,
        '49535343-fe7d-4ae5-8fa9-9fafd205e455',
        '49535343-1e4d-4bd9-ba61-23c647249616'
      )
      .subscribe(
        async (data) => {
          data = data[0];
          console.log('[bleNotifications] Toutes les actions en cours : ', this.currentAction);
          console.log('[bleNotifications] CurrentAction : ', this.currentAction[0]);
          console.log('[bleNotifications] Réponse : ', data);
          console.log('[bleNotifications] Réponse : ', this.buf2hex(data));

          this.sendingCmd = false;
          this.taskAction = this.currentAction[0];

          switch (this.currentAction[0]) {
            case 'openDoor': {
              /*if (this.stopInput == false)
            this.cmdLoader.dismiss();*/
              this.openService.receiveResponse(data);
              this.currentAction.shift();
              // this.changedRef.detectChanges();

              var body = [
                {
                  userId: this.user.id,
                  deviceId: this.device.id,
                  siteId: this.device.siteId,
                  accessId: 0,
                  properties: {
                    type: 'deviceController.door_open',
                    level: 'alert',
                    payload: {},
                    creationDate: new Date().getTime(),
                  },
                },
              ];

              console.log('API OPEN DOOR');
              await this.deviceApi
                .siteDeviceAddEventAll(this.device.id, body)
                .toPromise()
                .then(
                  (res) => {
                    console.log('Open DOOR API RES : ', res);
                  },
                  (error) => {
                    console.log('Open Door Event : ', error);
                  }
                );

              if (this.connectToOpenDoor) {
                this.connectToOpenDoor = false;
                this.syncTasks();
              }
              break;
            }
            case 'unique': {
              /*if (this.stopInput == false)
            this.cmdLoader.dismiss();*/
              this.uniqueResponse = this.uniqueService.receiveResponse(data);
              this.currentAction.shift();
              //this.changedRef.detectChanges();
              break;
            }
            case 'battery': {
              /*if (this.stopInput == false)
            this.cmdLoader.dismiss();*/
              this.batteryValue = this.batteryService.receiveResponse(data);

              if (this.batteryValue > 2 && this.batteryValue < 7000) {
                const body = [
                  {
                    properties: {
                      payload: {
                        type: 'voltage',
                        voltage: this.batteryValue / 1000,
                      },
                    },
                  },
                ];

                await this.deviceApi
                  .siteDeviceBattery(this.device.id, body)
                  .toPromise()
                  .then(
                    (res) => {
                      console.log(res);
                    },
                    (error) => {
                      console.log('Battery : ', error);
                    }
                  );
              }

              this.currentAction.shift();
              console.log('BleService - battery info received and send to API, syncEnd');
              this.syncSubject.next({ device: this.device, status: 'end' });
              //this.changedRef.detectChanges();
              break;
            }
            case 'join': {
              /* if (this.stopInput == false)
             this.cmdLoader.dismiss();*/
              this.joinLoraService.receiveResponse(data);
              this.currentAction.shift();
              //this.changedRef.detectChanges();
              break;
            }
            case 'hour': {
              /* if (this.stopInput == false)
             this.cmdLoader.dismiss();*/
              this.hourService.receiveResponse(data);
              this.currentAction.shift();
              // this.stopInput = false;
              //this.changedRef.detectChanges();

              this.useCmd('battery');
              break;
            }
            case 'stock': {
              /*if (this.stopInput == false)
            this.cmdLoader.dismiss();*/
              this.stockService.receiveResponse(data);
              this.currentAction.shift();
              //this.changedRef.detectChanges();
              break;
            }
            case 'events': {
              this.eventResponse = await this.eventService.receiveResponse(data);
              console.log('Notif response EVENT : ', this.eventResponse);

              /* if (this.cmdLoader != null) {
             this.cmdLoader.dismiss();
           }*/

              if (this.eventResponse == 'end') {
                const body = {
                  value: new Date().toISOString(),
                };

                this.eventService.sendEventToApi().then(() => {
                  // this.getEventsCount();
                  if (this.isEventsListVisible) {
                    // this.getEvents();
                  }
                  //this.changedRef.detectChanges();
                  this.eventSend = true;

                  /* if (this.stopInput == false)
                 this.cmdLoader.dismiss();*/
                  this.currentAction.shift();
                  //this.changedRef.detectChanges();

                  console.log(this.device.properties);
                  this.deviceApi.updateDevice(this.device.id, body, 'lastEvSync').subscribe((res) => {
                    console.log('Update end : ', res);
                    this.useCmd('hour');
                  });
                });
              } else if (this.eventResponse == '...') {
                /* if (this.stopInput == false)
               this.cmdLoader.dismiss();*/
                this.currentAction.shift();
                //this.changedRef.detectChanges();

                const body = {
                  value: new Date().toISOString(),
                };
                this.deviceApi.updateDevice(this.device.id, body, 'lastEvSync').subscribe((res) => {
                  console.log('Update end : ', res);
                  this.useCmd('hour');
                });
              }

              break;
            }
            case 'params': {
              /* if (this.stopInput == false)
             this.cmdLoader.dismiss();*/
              console.log(this.paramsService.receiveResponse(data));
              this.taskResponse = this.paramsService.receiveResponse(data);
              this.currentAction.shift();
              //this.changedRef.detectChanges();

              if (this.taskResponse == '3a0100') {
                this.paramsIsOk = true;
                /* this.currentAction.push('params');
             this.actionParams.readParam(this.paramIndex);*/
              }
              break;
            }
            case 'update': {
              let result = this.updateService.receiveResponse(data);

              if (result == null) {
                this.currentAction.shift();
                return;
              }

              console.log('Update Result: ', result);
              console.log('Length : ', result.length);

              if (this.checkUpdate == true) {
                this.parseUpdate(result);
                this.checkUpdate = false;
                this.currentAction.shift();
                this.syncTasks();
                return;
              }

              if (result.length == 12) {
                console.log('UPDATE LENGTH 8');
                // this.cmdLoader.dismiss();
                result = result.substring(4, result.length);
                let msg = '';

                console.log(result);
                switch (result) {
                  case '8c0c00fe': {
                    console.log('0');
                    msg = 'Erreur de CRC';
                    break;
                  }
                  case '2e5100fe': {
                    console.log('1');
                    msg = 'Erreur sur la taille de fichier';
                    break;
                  }
                  case 'c81000fe': {
                    console.log('2');
                    msg = 'Erreur unlock de la flash interne';
                    break;
                  }
                  case '081a0bfe': {
                    console.log('3');
                    msg = "Erreur sur la vérification de l'effacement";
                    break;
                  }
                  case 'f181aefe': {
                    console.log('4');
                    msg = 'Erreur sur la vérification de la programmation';
                    break;
                  }
                  case '8dca1dfe': {
                    console.log('5');
                    msg = "Le firmware n'est pas sur le bon produit";
                    break;
                  }
                  case '3e7100fe': {
                    console.log('6');
                    msg = "Délai dépassé pour recevoir une réponse de la part de 'application";
                    break;
                  }
                  case '000000fe': {
                    console.log('7');
                    msg = 'Erreur diverse lors de la mise à jour';
                    break;
                  }
                  case 'a7dfaafe': {
                    console.log('8');
                    msg = 'Hard fault';
                    break;
                  }
                  case '00e0a71d': {
                    this.hasToUpdate = false;

                    let body = {
                      value: '',
                    };

                    body.value = 'CarteLoraWan_v' + this.updateDispo + '.maj';
                    let type = 'config.mainFwVersion';

                    this.deviceApi.updateDevice(this.device.id, body, type).subscribe((res) => {
                      console.log('Update end : ', res);
                    });

                    msg = 'Mise à jour réussie';
                    break;
                  }
                }

                const alert = await this.alertCtrl.create({
                  message: msg,
                  buttons: [
                    {
                      text: 'Ok',
                      handler: () => {
                        this.currentAction.shift();
                        alert.dismiss();
                      },
                    },
                  ],
                });
                await alert.present();
              } else {
                // if (result != '99')
                //   this.cmdLoader.message = 'Mise à jour ' + result + '%';
                // else this.cmdLoader.message = 'Redémarage en cours ...';
                this.updateProgress.next(Number(result));
                this.device.syncProgress = result / 100;
                this.syncSubject.next({
                  device: this.device,
                  status: 'update',
                });
              }
              //this.changedRef.detectChanges();
            }
            case 'none': {
            }
            default: {
              console.log('Je suis la cmd par defaut');
              break;
            }
          }
          if (this.cmdFromTask) {
            this.validateTask();
          }
        },
        (err) => {
          console.log('Notification erreur : ', err);
        }
      );
    // this.changedRef.detectChanges();
  }

  parseUpdate(value) {
    console.log('ParseUpdate : ', value);
    //La réponse du cylindre doit faire 9 octets, ex: 3a0600300000050000
    if (value.length !== 18 || value.substring(2, 6) != '0600') {
      console.log('Error while reading firmware version response:', value);
      return;
    }
    const fwVersion = {
      major: parseInt(value.substring(10, 12) || 0, 16),
      minor: parseInt(value.substring(8, 10) || 0, 16),
      patch: parseInt(value.substring(6, 8) || 0, 16),
    };
    const rfidVersion = {
      major: parseInt(value.substring(16, 18) || 0, 16),
      minor: parseInt(value.substring(14, 16) || 0, 16),
      patch: parseInt(value.substring(12, 14) || 0, 16),
    };

    // this.mainVersion = parseInt(value.substring(6, 8), 16);
    this.mainVersion = `${fwVersion.major}.${fwVersion.minor}.${fwVersion.patch}`;
    this.rfidVersion = `${rfidVersion.major}.${rfidVersion.minor}.${rfidVersion.patch}`;
    this.HTTP.sendRequest(
      'https://storage.gra.cloud.ovh.net/v1/AUTH_9d177826801d427c9e69e0ec2e22422a/solupass_firmwares/latest.json',
      {
        method: 'get',
      }
    ).then(
      (res) => {
        console.log('Latest.json : ', res);
        // const cylindreValue = parseInt(value.substring(6, 8), 16);
        const data = JSON.parse(res.data);
        // let apiValue = parseInt(data.mainfw.split('.')[2]);
        let apiMainVersion;
        try {
          let apiMain = data.mainfw.replace('v', '').split('_')[1].split('.');
          apiMainVersion = `${apiMain[0]}.${apiMain[1]}.${apiMain[2]}`;
        } catch (e) {
          console.log('Error while reading api fw version:', e);
          return;
        }

        console.log('Checking main FW version ========> ', this.mainVersion + ' -- ' + apiMainVersion);
        this.updateDispo = apiMainVersion;
        this.storage.set('updateDispo', this.updateDispo);
        // if (this.mainVersion < apiMainVersion) {
        if (compare(this.mainVersion, apiMainVersion, '<')) {
          console.log('Update disponible');
          this.hasUpdate = true;
          this.isTechInfoVisible = true;
          // this.changedRef.detectChanges();
        } else {
          this.hasUpdate = false;
        }

        //maj infos fw en base

        let bodyMain = {
          value: 'CarteLoraWan_v' + this.mainVersion + '.maj',
        };
        this.deviceApi.updateDevice(this.device.id, bodyMain, 'config.mainFwVersion').subscribe((res) => {
          console.log('Update end : ', res);
        });

        let apiRfidVersion;
        try {
          let apiRfid = data.rfidfw.replace('v', '').split('_')[2].split('.');
          let apiRfidVersion = `${apiRfid[0]}.${apiRfid[1]}.${apiRfid[2]}`;
        } catch (e) {
          console.log('Error while reading api rfid version:', e);
          return;
        }

        console.log('Checking RFID FW version VALUE ========> ', this.rfidVersion + ' -- ' + apiRfidVersion);

        // // if (this.rfidVersion < apiValue) {
        //   if(this.compVersions(this.rfidVersion,apiRfidVersion) < 0) {
        //   console.log('Update disponible');
        //   this.hasUpdate = true;
        //   this.isTechInfoVisible = true;
        //   this.updateDispo = apiRfidVersion;
        //   this.changedRef.detectChanges();
        // } else {
        //   this.hasUpdate = false;
        // }

        //maj infos fw en base

        let bodyRfid = {
          value: 'NFC_Reader_v' + this.rfidVersion + '.maj',
        };
        this.deviceApi.updateDevice(this.device.id, bodyRfid, 'config.rfidFwVersion').subscribe((res) => {
          console.log('Update end : ', res);
        });
      },
      async (error) => {
        const alert = await this.alertCtrl.create({
          message: "Aucune réponse de l'API ovh",
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                // this.cmdLoader.dismiss();
                alert.dismiss();
              },
            },
          ],
        });
        await alert.present();
      }
    );
  }

  async useCmd(cmd, infos = null) {
    // if (this.router.url.includes('/device/detail') == false) return;

    // console.log('useCMD : ' + this.cmdLoader + ' - ' + cmd);

    this.cmd = cmd;

    // if (this.cmdLoader != null) {
    //   try {
    //     this.cmdLoader.dismiss();
    //   } catch (e) {
    //     console.log('Error while dismissing cmdLoader:', e);
    //   }
    // }

    /* if (this.cmdLoader == null) {
       this.cmdLoader = await this.loaderCtrl.create({
         message: "Envois de commande : [" + cmd + "]"
       })
     } else if (this.cmdLoader != null && this.stopInput == false) {
       this.cmdLoader.dismiss();

       this.cmdLoader = await this.loaderCtrl.create({
         message: "Envois de commande : [" + cmd + "]"
       })
     } else {
       this.cmdLoader.message = "Envois de commande : [" + cmd + "]"
     }

     this.clearTimeout();*/

    this.sendingCmd = true;
    // setTimeout(async () => {
    //   //Amaury -> Msg d'erreur si au bout de 15s la commande retour n'est pas reçue
    //   //pertinence lorsque plusieurs commandes (cheuvauchement)?
    //   if (this.sendingCmd == true) {
    //     this.sendingCmd = false;
    //     // this.stopInput = false;
    //     this.currentAction.shift();
    //     // try {
    //     //   this.cmdLoader.dismiss();
    //     // } catch (e) {
    //     //   console.log('Error while dismissing cmdLoader in setTimeout:', e);
    //     // }
    //     // const alert = await this.alertCtrl.create({
    //     //   message: 'Aucune réponse du cylindre sur la commande : [' + cmd + ']',
    //     //   buttons: [
    //     //     {
    //     //       text: 'Ok',
    //     //       handler: () => {
    //     //         alert.dismiss();
    //     //       },
    //     //     },
    //     //   ],
    //     // });
    //     // await alert.present();
    //   }
    // }, 20000);

    this.currentAction.push(cmd);

    const delay = ['update'].includes(cmd) ? 1000 : 300;

    console.log('Wait ', delay, 'before sending ', cmd);
    const self = { ...this };
    setTimeout(async () => {
      console.log('bleservice - userCmd timeout');
      //check that current device has not changed
      if (this.device.id !== self.device.id) {
        console.log('device:', self.device.bleId, 'has changed to :', this.device.bleId, ',dimiss');
        return;
      }
      //If we are still trying to send the same task (stucked), disconnect and
      //display an error
      if (
        this.sendingCmd === true &&
        self.currentTaskId === this.currentTaskId &&
        self.currentCmdId === this.currentCmdId
      ) {
        console.log('Still sending command (stucked) without response, disconnect device', this.device);
        this.sendingCmd = false;
        this.syncSubject.next({ device: this.device, status: 'bt_error' });
        this.disconnect();
      }
    }, delay + 10000);

    //ajout par amaury (pas dans synchro cadenas) -> attend 1s avant d'envoyer
    //chaque commande... visiblement suite bug innovel??
    setTimeout(async () => {
      switch (cmd) {
        case 'openDoor': {
          //  this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.OPENDOOR');
          this.openService.sendMessage();
          break;
        }
        case 'battery': {
          //   this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.BATTERY');
          this.batteryService.sendMessage();
          break;
        }
        case 'join': {
          //  this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.JOIN');
          this.joinLoraService.sendMessage();
          break;
        }
        case 'hour': {
          //    this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.HOUR');
          this.hourService.sendMessage();
          break;
        }
        case 'stock': {
          //    this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.STOCK');
          this.stockService.sendMessage();
          break;
        }
        case 'update': {
          // if (this.cmdLoader == null) {
          //   this.cmdLoader = await this.loaderCtrl.create({
          //     message: this.translate.instant('DEVICEBLE.CMD.UPDATE'),
          //   });
          // }

          console.log('infos : ', infos);
          this.isUpdating = true;
          if (infos == 0) this.updateService.getFile(this.updateInfos);
          else if (infos == 1) {
            this.updateService.checkStatus();
            this.updateEnd = false;
          } else this.updateService.getFile(this.updateDispo);
          //   this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.UPDATE');

          // this.cmdLoader.present();
          break;
        }
        case 'params': {
          //   this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.PARAMS');
          this.paramsService.prepareCmd(infos);
          //this.paramsService.sendMessage();
          break;
        }
        case 'events': {
          this.checkEventt = false;
          this.isConnecting = false;
          //   this.cmdLoader.message = this.translate.instant('DEVICEBLE.CMD.EVENTS');
          this.eventService.sendMessage();
          break;
        }
        case 'unique': {
          console.log('[Cmd perso] : ', this.uniqueInput);
          this.uniqueService.prepareCmd(this.uniqueInput);
          this.uniqueService.sendMessage();
          break;
        }
        default:
          break;
      }
    }, delay);
  }

  async update() {
    console.log('AAAAA');
    this.isUpdating = true;
    this.storage.set('fromScan', true);
    this.useCmd('update');
  }

  async forceUpdate() {
    if (!this.updateDispo) {
      this.updateDispo = await this.storage.get('updateDispo');
    }
    this.update();
  }
}
